import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableSupportPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableSupportPage;
